import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { contentGeneratorConfigPopulatedSchema } from "@redotech/redo-model/content-generator-config/content-generator-config-definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const createContentGeneratorConfigInputSchema_ = z.object({
  schemaType: createEnum(SchemaType),
  isRecover: z.boolean().optional(),
});
export interface CreateContentGeneratorConfigInput
  extends z.infer<typeof createContentGeneratorConfigInputSchema_> {}
export const createContentGeneratorConfigInputSchema: z.ZodType<CreateContentGeneratorConfigInput> =
  createContentGeneratorConfigInputSchema_;

export const createContentGeneratorConfig = {
  name: "createContentGeneratorConfig" as const,
  input: createContentGeneratorConfigInputSchema,
  output: contentGeneratorConfigPopulatedSchema,
};
